export default __webpack_public_path__ + "static/partner-welcome-7d1ec001257ebd51f43a8e7b235bb577.png";